import { RegisterItemContentVariant } from '@modules/registers/items/types'
import { localizedStrings } from '@core/strings'

export const emptyValue = (variant: RegisterItemContentVariant) => {
  if (variant === 'table') {
    return ''
  }
  return localizedStrings.na
}
